<template>
  <div class="share-container">
    <div class="page-header">
      <div class="header-left">
        <h2 class="page-title">我的分享</h2>
        <span class="sub-title">管理你已分享给好友的内容</span>
      </div>
    </div>

    <div class="table-card">
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="dataList"
        class="pikpak-table"
        style="width: 100%"
      >
        <el-table-column label="合集名称" min-width="250">
          <template slot-scope="scope">
            <div class="album-info-cell">
              <i class="el-icon-folder-opened album-icon" />
              <span class="album-name">{{ scope.row.albumName }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="albumType" label="类型" width="120">
          <template slot-scope="scope">
            <el-tag :type="getTagType(scope.row.albumType)" size="medium" effect="light" round>
              {{ scope.row.albumType }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="shareAt" label="分享时间" width="180" />

        <el-table-column label="被分享用户" width="180">
          <template slot-scope="scope">
            <div class="share-count-cell">
              <span class="user-num">{{ scope.row.num }} 位用户</span>
              <el-button
                type="text"
                icon="el-icon-view"
                class="view-btn"
                @click="getShareToList(scope.row)"
              >
                查看
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="120" align="right" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              class="delete-btn"
              icon="el-icon-delete"
              @click="deleteShare(scope.row)"
            >取消分享</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrapper">
        <el-pagination
          background
          hide-on-single-page
          :small="screenWidth <= 768"
          layout="total, prev, pager, next"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="totalSize"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <el-dialog
      title="分享名单"
      :visible.sync="showShareToDialog"
      width="400px"
      append-to-body
      custom-class="pikpak-dialog"
    >
      <div class="share-user-list">
        <div v-if="shareToList.length === 0" class="empty-list">暂无分享用户</div>
        <div v-for="(user, index) in shareToList" :key="index" class="user-item">
          <el-avatar :size="32" icon="el-icon-user" />
          <span class="user-name">{{ user.username }}</span>
          <el-tag size="mini" type="info">已查看</el-tag>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" round block style="width: 100%" @click="showShareToDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { deleteShare, getShareList, getShareToList } from '@/api/disk'

export default {
  name: 'DiskShare',
  data() {
    return {
      screenWidth: document.body.clientWidth,
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      dataList: [],
      loading: false,
      showShareToDialog: false,
      shareToList: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    handleCurrentChange(pageNumber) {
      this.currentPage = pageNumber
      this.getData()
    },
    getData() {
      this.loading = true
      getShareList(this.currentPage).then(resp => {
        if (resp.code === 0) {
          this.dataList = resp.data.list
          this.totalSize = resp.data.totalSize
        } else {
          this.$message.error(resp.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getTagType(type) {
      const map = { '视频': 'danger', '图片': 'success', '文档': 'warning' }
      return map[type] || 'info'
    },
    getShareToList(row) {
      getShareToList(row.shareId).then(resp => {
        if (resp.code === 0) {
          this.shareToList = resp.data
          this.showShareToDialog = true
        }
      })
    },
    deleteShare(row) {
      this.$confirm(`确定要取消针对 "${row.albumName}" 的分享吗？`, '取消分享', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
        roundButton: true
      }).then(() => {
        deleteShare(row.shareId).then(resp => {
          if (resp.code === 0) {
            this.$message.success('已取消分享')
            this.getData() // 刷新数据而不是刷新整个页面
          } else {
            this.$message.error(resp.msg)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.share-container {
  padding: 10px;
}

.page-header {
  margin-bottom: 24px;
}

.page-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.sub-title {
  font-size: 13px;
  color: #909399;
  margin-top: 4px;
  display: block;
}

/* 表格样式美化 */
.table-card {
  background: #fff;
  border-radius: 12px;
}

.pikpak-table ::v-deep .el-table__header th {
  background-color: transparent;
  color: #5f6368;
  font-weight: 600;
  border-bottom: 1px solid #f0f0f0;
}

.pikpak-table ::v-deep .el-table__row {
  transition: background 0.2s;
}

.album-info-cell {
  display: flex;
  align-items: center;
}

.album-icon {
  font-size: 24px;
  color: #ffca28;
  margin-right: 12px;
}

.album-name {
  font-weight: 500;
  color: #333;
}

.share-count-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-num {
  color: #f56c6c;
  font-weight: 600;
}

.delete-btn {
  color: #909399;
}
.delete-btn:hover {
  color: #f56c6c;
}

.pagination-wrapper {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}

/* 用户列表弹窗 */
.share-user-list {
  max-height: 300px;
  overflow-y: auto;
}

.user-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f5f7fa;
}

.user-name {
  flex: 1;
  margin-left: 12px;
  font-size: 14px;
  color: #333;
}

.empty-list {
  text-align: center;
  padding: 30px;
  color: #999;
}

::v-deep .pikpak-dialog {
  border-radius: 16px;
}
</style>
